import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { FileSignature, FilePlus2, LayoutTemplate, PenLine } from 'lucide-react';

const TABS = [
  { to: '/contracts', label: 'Generar', icon: FilePlus2, end: true, desc: 'Contratos generados desde el CRM y el asistente para crear uno nuevo' },
  { to: '/contracts/plantillas', label: 'Plantillas', icon: LayoutTemplate, end: false, desc: 'La plantilla maestra de cada modelo, sus versiones y los preajustes con condiciones ya negociadas' },
  { to: '/contracts/firmas', label: 'Firmas', icon: PenLine, end: false, desc: 'Seguimiento de las firmas en Click & Sign' },
];

/**
 * Clientes › Contratos agrupa tres cosas que antes eran una: generar el
 * contrato desde el CRM, mantener la plantilla y seguir la firma. Cada pestaña
 * conserva su ruta para que siga siendo enlazable.
 */
export default function ContratosLayout() {
  const { pathname } = useLocation();
  const activa = TABS.find(t => (t.end ? pathname === t.to : pathname.startsWith(t.to))) ?? TABS[0];

  return (
    <div>
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 rounded-lg bg-sereno-blue/50 text-sereno-dark">
          <FileSignature size={22} />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Contratos</h1>
          <p className="text-sm text-sereno-dark/50">{activa.desc}</p>
        </div>
      </div>

      <div className="border-b border-slate-200 dark:border-white/10 mb-6">
        <nav className="flex gap-1 -mb-px overflow-x-auto -mx-4 px-4 sm:mx-0 sm:px-0 scrollbar-none">
          {TABS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-3 sm:px-4 py-3 sm:py-2.5 text-sm whitespace-nowrap border-b-2 transition-colors ${
                  isActive
                    ? 'border-sereno-dark text-sereno-dark font-medium dark:border-white dark:text-white'
                    : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                }`
              }
            >
              <Icon size={15} />
              {label}
            </NavLink>
          ))}
        </nav>
      </div>

      <Outlet />
    </div>
  );
}
